import React from 'react'
import { withScriptjs, withGoogleMap, Polygon, GoogleMap } from "react-google-maps"

const SuburbMap = (props) => {
  const bounds = new window.google.maps.LatLngBounds();

  props.polygonCoords.map(({ lat, lng }) => {
    const latLng = new window.google.maps.LatLng(lat, lng);
    bounds.extend(latLng);
    return latLng;
  });

  return (
    <GoogleMap
      ref={ node => node && node.fitBounds(bounds) }
      defaultZoom={13}>
      <Polygon
        paths={props.polygonCoords}
        options={{
          strokeColor: "#DC716B",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#EAE0DE",
          fillOpacity: 0.35
        }}
      />
    </GoogleMap>
  )
}

export default withScriptjs(withGoogleMap(SuburbMap))
